module.exports = __webpack_public_path__ + "static/media/mustTry4.f7dcf536.jpg";